import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";

/**
 * Created by Jerker Nord on 2022-04-12.
 */

export class TheBorderTimelineSprite extends TimelineSprite{

    private _used:boolean;

    constructor(textures: PIXI.Texture[], sourceFPS?: number) {
        super(textures, sourceFPS);
        this._used = false;
    }

    get used():boolean {
        return this._used;
    }

    set used(value:boolean) {
        this._used = value;
    }
}